import { useEffect, useState } from 'react';
import { InterfaceServices } from '../../interfaces/Interfaces';
import ListApi from '../../api/genericApis/List.api';
import { Link } from 'react-router-dom';
import { EditServiceRoute, routes } from '../../consts/consts';
import ServiceCardSkeleton from '../shared/card/ServiceCardSkeleton';
import { ModuleType } from '../../api/modules.types';
import FilterAndSearch from '../shared/FilterAndSearch';
import ServiceCard from '../shared/card/ServiceCard';

export default function ServicesTable() {
  const [list, setList] = useState<InterfaceServices[]>([]);
  const [filteredList, setFilteredList] = useState<InterfaceServices[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [activeFilter, setActiveFilter] = useState<
    'all' | 'active' | 'inactive'
  >('all');
  const [searchQuery, setSearchQuery] = useState<string>('');

  const getList = async () => {
    setLoading(true);
    await ListApi({ moduleType: ModuleType.services })
      .then((response) => {
        setList(response.data);
        setFilteredList(response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    let filtered = list;

    if (activeFilter !== 'all') {
      filtered = filtered.filter(
        (item) =>
          (activeFilter === 'active' && item.serviceStatus === 1) ||
          (activeFilter === 'inactive' && item.serviceStatus === 0),
      );
    }

    if (searchQuery) {
      filtered = filtered.filter(
        (item) =>
          item.serviceTitleEn
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          item.serviceDescriptionEn
            .toLowerCase()
            .includes(searchQuery.toLowerCase()),
      );
    }

    setFilteredList(filtered);
  }, [activeFilter, searchQuery, list]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h3>Blueprint Services List</h3>

        <Link to={routes.addService} className="btn btn-primary">
          Add Service
        </Link>
      </div>
      {/* Filter and Search Inputs */}
      <FilterAndSearch
        activeFilter={activeFilter}
        searchQuery={searchQuery}
        onFilterChange={setActiveFilter}
        onSearchChange={setSearchQuery}
      />

      <div className="row">
        {loading && <ServiceCardSkeleton />}
        {!loading && filteredList && filteredList.length > 0 ? (
          filteredList.map((item, index) => (
            <ServiceCard
              key={index}
              title={item.serviceTitleEn}
              city={item.serviceDescriptionEn}
              imageUrl={item.serviceImageUrl}
              status={item.serviceStatus === 1}
              id={item.serviceId}
              editRoute={EditServiceRoute(item.serviceId)}
              moduleType={ModuleType.service}
              getList={getList}
            />
          ))
        ) : (
          <p>No Services found</p>
        )}
      </div>
    </div>
  );
}
